import { HostMessageType } from '../../interfaces/host-message-types';
import { sendMessageToHost } from '../base/models/base-message';
import { MessageHandler } from '../base/interfaces/message.interface';

export const InitializedMessage: MessageHandler<undefined> = {
  send(payload = undefined, targetOrigin = '*'): void {
    sendMessageToHost(HostMessageType.Initialized, payload, targetOrigin);
  },

  validatePayload(payload: unknown): payload is undefined {
    return payload === undefined;
  },
};
